import React, { Component } from 'react';

import { Pie } from 'react-chartjs-2';

class PieChart extends Component {
	constructor() {
		super();
		this.state = {
			totMemoryCards: 0,
			tempdata: [],
			memoryCardsNumbers: [],
		};
	}
	getAllPieChartData = (type) => {
		let tc = 0;
		let rc = 0,
			isc = 0,
			cpc = 0,
			vpc = 0,
			rpc = 0,
			oc = 0;
		if (type.data.length !== 0) {
			for (let i = 0; i < type.data.length; i++) {
				tc += type.data[i].total;
				for (let j = 0; j < type.data[i].subStatusModel.length; j++) {
					if (type.data[i].subStatusModel[j].subStatus === null) {
						oc += type.data[i].subStatusModel[j].subStatusCount;
					}
					if (type.data[i].subStatusModel[j].subStatus === 'copyPending') {
						cpc += type.data[i].subStatusModel[j].subStatusCount;
					}
					if (type.data[i].subStatusModel[j].subStatus === 'releasePending') {
						rpc += type.data[i].subStatusModel[j].subStatusCount;
					}
					if (type.data[i].subStatusModel[j].subStatus === 'verificationPending') {
						vpc += type.data[i].subStatusModel[j].subStatusCount;
					}
					if (type.data[i].subStatusModel[j].subStatus === 'ready') {
						rc += type.data[i].subStatusModel[j].subStatusCount;
					}
					if (type.data[i].subStatusModel[j].subStatus === 'inShoot') {
						isc += type.data[i].subStatusModel[j].subStatusCount;
					}
				}
			}
			this.setState({
				memoryCardsNumbers: [rc, isc, cpc, vpc, rpc, oc],
			});
			rc = ~~((rc / tc) * 100);
			isc = ~~((isc / tc) * 100);
			cpc = ~~((cpc / tc) * 100);
			vpc = ~~((vpc / tc) * 100);
			rpc = ~~((rpc / tc) * 100);
			oc = ~~((oc / tc) * 100);

			this.setState({
				totMemoryCards: tc,
				tempdata: [rc, isc, cpc, vpc, rpc, oc],
			});
		}
	};

	componentDidMount = () => {
		this.getAllPieChartData(this.props);
	};
	componentWillReceiveProps = (nextProps) => {
		this.getAllPieChartData(nextProps);
	};

	render() {
		return (
			<>
				<div
					className="main-bod"
					style={{
						width: '35vw',
						border: '0.5px solid #383838',
						padding: '10px',
						marginTop: '30px',
						marginBottom: '30px',
						display: 'flex',
						alignItems: 'center',
						backgroundColor: '#1C1C1C',
						// gap: '30px',
						justifyContent: 'space-between',
					}}
				>
					<div
						className="chart-container"
						style={{
							height: '160px',
							width: '160px',
						}}
					>
						<Pie
							data={{
								// labels: [
								//     'Ready',
								//     'In Shoot',
								//     'Copy Pending',
								//     'Verification Pending',
								//     'Release Pending',
								//     'Others',
								// ],
								datasets: [
									{
										label: '% of Cards',
										data: this.state.tempdata,
										backgroundColor: [
											'#479A5F',
											'#589ABB',
											'#BD3614',
											'#E2793A',
											'#EBC658',
											'#707070',
										],
										borderColor: [
											'#479A5F',
											'#589ABB',
											'#BD3614',
											'#E2793A',
											'#EBC658',
											'#707070',
										],
										borderWidth: 1,
									},
								],
							}}
						/>
					</div>
					<div
						className="labels-bod"
						style={{
							display: 'flex',
							flexDirection: 'column',
							gap: '15px',
						}}
					>
						<div
							className="sublabel"
							style={{
								display: 'flex',
								alignItems: 'center',
								gap: '8px',
								color: 'white',
							}}
						>
							<div
								className="blocks"
								style={{
									backgroundColor: '#479A5F',
									height: '10px',
									width: '10px',
									borderRadius: '50%',
								}}
							></div>
							<p> Ready</p>
						</div>
						<div
							className="sublabel"
							style={{
								display: 'flex',
								alignItems: 'center',
								gap: '8px',
							}}
						>
							<div
								className="blocks"
								style={{
									backgroundColor: '#589ABB',
									height: '10px',
									width: '10px',
									borderRadius: '50%',
								}}
							></div>
							<p style={{ color: 'white' }}>In Shoot</p>
						</div>
						<div
							className="sublabel"
							style={{
								display: 'flex',
								alignItems: 'center',
								gap: '8px',
							}}
						>
							<div
								className="blocks"
								style={{
									backgroundColor: '#BD3614',
									height: '10px',
									width: '10px',
									borderRadius: '50%',
								}}
							></div>
							<p style={{ color: 'white' }}>Copy Pending</p>
						</div>
						<div
							className="sublabel"
							style={{
								display: 'flex',
								alignItems: 'center',
								gap: '8px',
							}}
						>
							<div
								className="blocks"
								style={{
									backgroundColor: '#E2793A',
									height: '10px',
									width: '10px',
									borderRadius: '50%',
								}}
							></div>
							<p style={{ color: 'white' }}>Verification Pending</p>
						</div>
						<div
							className="sublabel"
							style={{
								display: 'flex',
								alignItems: 'center',
								gap: '8px',
							}}
						>
							<div
								className="blocks"
								style={{
									backgroundColor: '#EBC658',
									height: '10px',
									width: '10px',
									borderRadius: '50%',
								}}
							></div>
							<p style={{ color: 'white' }}> Release Pending</p>
						</div>
						<div
							className="sublabel"
							style={{
								display: 'flex',
								alignItems: 'center',
								gap: '8px',
							}}
						>
							<div
								className="blocks"
								style={{
									backgroundColor: ' #707070',
									height: '10px',
									width: '10px',
									borderRadius: '50%',
								}}
							></div>
							<p style={{ color: 'white' }}> others</p>
						</div>
					</div>
					<div
						className="numb_bod"
						style={{
							display: 'flex',
							flexDirection: 'column',
							gap: '15px',
							color: 'white',
						}}
					>
						<p>{this.state.memoryCardsNumbers[0]}</p>

						<p>{this.state.memoryCardsNumbers[1]}</p>

						<p>{this.state.memoryCardsNumbers[2]}</p>

						<p>{this.state.memoryCardsNumbers[3]}</p>

						<p>{this.state.memoryCardsNumbers[4]}</p>

						<p>{this.state.memoryCardsNumbers[5]}</p>
					</div>
					<div
						className="percent_bod"
						style={{
							display: 'flex',
							flexDirection: 'column',
							gap: '15px',
							// marginLeft: '-60px',
						}}
					>
						<p style={{ color: '#707070' }}> {this.state.tempdata[0]}%</p>
						<p style={{ color: '#707070' }}> {this.state.tempdata[1]}%</p>
						<p style={{ color: '#707070' }}> {this.state.tempdata[2]}%</p>
						<p style={{ color: '#707070' }}> {this.state.tempdata[3]}%</p>
						<p style={{ color: '#707070' }}> {this.state.tempdata[4]}%</p>
						<p style={{ color: '#707070' }}> {this.state.tempdata[5]}%</p>
					</div>
				</div>
			</>
		);
	}
}
export default PieChart;
